var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"value":_vm.value,"items":_vm.users,"label":_vm.label,"item-text":"displayName","return-object":"","clearable":_vm.clearable,"dense":_vm.dense,"outlined":_vm.outlined,"multiple":_vm.multiple,"hide-details":_vm.hideDetails},on:{"input":_vm.input}})
}
var staticRenderFns = []

export { render, staticRenderFns }